define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'jump', 'module-gallery',
        'module-trailer', 'module-episode', 'module-character', 'module-video-player', 'module-quiz',
        'module-movie-guide', 'module-spotify', 'module-about', 'module-program-tv'],
    function ($, transit, modernizr, container, preloader, jumpFactory, moduleGallery,
              moduleTrailer, moduleEpisode, moduleCharacter,
              moduleVideoPlayer, moduleQuiz, moduleMovieGuide, moduleSpotify, moduleAbout, moduleProgramTv) {


        return (function () {

            const name = 'series-details';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);

            const jump = jumpFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                submenu: {
                    active: false,
                    current: 'featured',
                    target: null,
                },
                items: new Map(),
                itemsKeys: [],
                canNavigateAction: 0,
            };

            view.startup = function () {

                preloader.setPreloadBulk(name + ' - startup', view.publicVars.preloadTab);

                if(view.publicVars.moduleFeaturedEnabled) {
                    view.privateVars.itemsKeys.push('featured');
                }

                if(view.publicVars.moduleStuntAboutEnabled) {
                    view.privateVars.itemsKeys.push('about');
                }

                if(view.publicVars.moduleTrailerConfig) {

                    view.privateVars.itemsKeys.push('trailer');

                    view.privateVars.items.set('trailer', {
                        init: false,
                        module: moduleTrailer,
                        config: view.publicVars.moduleTrailerConfig,
                        callbacks: {

                        }
                    });
                }

                if(view.publicVars.moduleMovieGuideConfig) {

                    view.privateVars.itemsKeys.push('movie-guide');

                    view.privateVars.items.set('movie-guide', {
                        init: false,
                        module: moduleMovieGuide,
                        config: view.publicVars.moduleMovieGuideConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleArchiveEnabled) {
                    view.privateVars.itemsKeys.push('archive');
                }

                if(view.publicVars.moduleAboutEnabled) {
                    view.privateVars.itemsKeys.push('about');

                    view.privateVars.items.set('about', {
                        init: false,
                        module: moduleAbout,
                        config: view.publicVars.moduleAboutConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleProgramTvConfig) {
                    view.privateVars.itemsKeys.push('program-tv');

                    view.privateVars.items.set('program-tv', {
                        init: false,
                        module: moduleProgramTv,
                        config: view.publicVars.moduleProgramTvConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleEpisodeConfig) {

                    view.privateVars.itemsKeys.push('episode');

                    view.privateVars.items.set('episode', {
                        init: false,
                        module: moduleEpisode,
                        config: view.publicVars.moduleEpisodeConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleCharacterConfig) {

                    view.privateVars.itemsKeys.push('character');

                    view.privateVars.items.set('character', {
                        init: false,
                        module: moduleCharacter,
                        config: view.publicVars.moduleCharacterConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleVideoPlayerConfig) {

                    view.privateVars.itemsKeys.push('video-player');

                    view.privateVars.items.set('video-player', {
                        init: false,
                        module: moduleVideoPlayer,
                        config: view.publicVars.moduleVideoPlayerConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleSpotifyConfig) {
                    view.privateVars.itemsKeys.push('spotify');

                    view.privateVars.items.set('spotify', {
                        init: false,
                        module: moduleSpotify,
                        config: view.publicVars.moduleSpotifyConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleGalleryConfig) {

                    view.privateVars.itemsKeys.push('gallery');

                    view.privateVars.items.set('gallery', {
                        init: false,
                        module: moduleGallery,
                        config: view.publicVars.moduleGalleryConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleQuizConfig) {

                    view.privateVars.itemsKeys.push('quiz');

                    view.privateVars.items.set('quiz', {
                        init: false,
                        module: moduleQuiz,
                        config: view.publicVars.moduleQuizConfig,
                        callbacks: {
                        }
                    });
                }

                if(view.publicVars.moduleLinkEnabled) {
                    view.privateVars.itemsKeys.push('link');
                }

                if(view.publicVars.moduleReadAboutEnabled) {
                    view.privateVars.itemsKeys.push('read-about');
                }

                if(view.publicVars.moduleRelatedEnabled) {
                    view.privateVars.itemsKeys.push('related');
                }

                if(view.publicVars.moduleVodEnabled) {
                    view.privateVars.itemsKeys.push('vod');
                }

                view.methods.calculateSubmenuHeight();

                let submenuIntervalCount = 1;
                let submenuInterval = setInterval(function () {
                    if(submenuIntervalCount > 10) {
                        clearInterval(submenuInterval);
                    }
                    view.methods.calculateSubmenuHeight();
                    submenuIntervalCount ++;
                }, 1000);

                view.methods.handleCurrentScrollPosition();

                // moduleMediaCarousel.init(view.publicVars.moduleMediaCarouselConfig);
                // moduleVideoCarousel.init(view.publicVars.moduleVideoCarouselConfig);

            };

            view.bind = function () {

                $(view.publicVars.cssId.submenu.headerSeriesSubmenuArrowWrapperCls).click(function () {
                    view.methods.openSubmenu();
                });

                $(view.publicVars.cssId.submenu.headerSeriesSubmenuCloseCls).click(function () {
                    view.methods.closeSubmenu();
                });

                $(view.publicVars.cssId.submenu.canNavigateCls).click(function () {
                    var target = container.getData($(this)[0], 'target');

                    container.msg('system - navigate target ' + target);

                    view.methods.performNavigate(target, {fireAnim: 1});

                    view.methods.closeSubmenu();
                });

                $(window).scroll(function () {

                    let ticking = false;

                    if (view.privateVars.canNavigateAction === 0) {

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                view.methods.handleCurrentScrollPosition();
                                ticking = false;
                            });
                        }
                        ticking = true;
                    }
                });

                $(window).resize(() => {
                    view.methods.calculateSubmenuHeight();
                    view.methods.handleCurrentScrollPosition();
                });

                $(window).on('orientationchange', () => {
                    view.methods.calculateSubmenuHeight();
                    view.methods.handleCurrentScrollPosition();
                });

                $(document).mouseup(function(e)
                {
                    var container = $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls);

                    if (!container.is(e.target) // if the target of the click isn't the container...
                        && container.has(e.target).length === 0) // ... nor a descendant of the container
                    {
                        view.methods.closeSubmenu();
                    }
                });
            };

            view.methods = {

                calculateSubmenuHeight: () => {

                    if($(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).length  < 1) {
                        return;
                    }

                    const windowWidth = $(window).width();

                    const itemsCount = $(view.publicVars.cssId.submenu.headerSeriesSubmenuContentItemCls).length;

                    if(windowWidth < 480) {
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasOneRowCls.substr(1));
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasTwoRowsCls.substr(1));
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasThreeRowsCls.substr(1));

                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).addClass(view.publicVars.cssId.submenu.hasItemsCls.substr(1) + itemsCount);
                        $(view.publicVars.cssId.submenu.containerSiteCls).addClass(view.publicVars.cssId.submenu.hasSeriesSubmenuItemsCls.substr(1) + itemsCount);
                    } else {
                        const submenuCopy = $(view.publicVars.cssId.submenu.headerSeriesSubmenuContentInnerCls).clone();
                        const itemCopy = $(view.publicVars.cssId.submenu.headerSeriesSubmenuContentInnerCls
                            + ' ' + view.publicVars.cssId.submenu.headerSeriesSubmenuContentItemCls + ':first-child').clone();

                        submenuCopy.html('');
                        submenuCopy.append(itemCopy);

                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).append(submenuCopy);

                        const baseSubmenuHeight = submenuCopy.outerHeight()

                        submenuCopy.remove();

                        const actualSubmenuHeight = $(view.publicVars.cssId.submenu.headerSeriesSubmenuContentInnerCls).outerHeight();

                        for(var i = 0; i <= itemsCount; i++) {
                            $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasItemsCls.substr(1) + '' + i);
                            $(view.publicVars.cssId.submenu.containerSiteCls).removeClass(view.publicVars.cssId.submenu.hasSeriesSubmenuItemsCls.substr(1) + '' + i);
                        }

                        if (actualSubmenuHeight > baseSubmenuHeight) {

                            if (actualSubmenuHeight > baseSubmenuHeight * 2) {
                                $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasOneRowCls.substr(1));
                                $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasTwoRowsCls.substr(1));
                                $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).addClass(view.publicVars.cssId.submenu.hasThreeRowsCls.substr(1));
                            } else {
                                $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasOneRowCls.substr(1));
                                $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasThreeRowsCls.substr(1));
                                $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).addClass(view.publicVars.cssId.submenu.hasTwoRowsCls.substr(1));
                            }

                        } else {

                            $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasTwoRowsCls.substr(1));
                            $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.hasThreeRowsCls.substr(1));
                            $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).addClass(view.publicVars.cssId.submenu.hasOneRowCls.substr(1));
                        }

                        container.msg(name + ' - base submenu height: ' + baseSubmenuHeight + ', actual submenu height: ' + actualSubmenuHeight);
                    }
                },

                openSubmenu: () => {
                    if(!view.privateVars.submenu.active) {

                        view.methods.calculateSubmenuHeight();

                        // const windowWidth = $(window).width();

                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).css({transition: 'all 0.3s ease-in'});

                        view.privateVars.submenu.active = true;
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).addClass(view.publicVars.cssId.submenu.isActiveCls.substr(1));
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuArrowWrapperCls).css({ display: 'none', opacity: 0});
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuContentInnerCls).css({ opacity: 1 });

                        setTimeout(function () {
                            $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).css({transition: 'initial'});
                        }, 350);

                        // if(windowWidth < 600) {
                        //     $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).css({ transform: 'translate(0, 0)'});
                        // }

                    }
                },

                closeSubmenu: () => {
                    if(view.privateVars.submenu.active) {

                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).css({transition: 'all 0.3s ease-in'});

                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).removeClass(view.publicVars.cssId.submenu.isActiveCls.substr(1));
                        view.privateVars.submenu.active = false;
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuArrowWrapperCls).css({ display: 'block'});
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuArrowWrapperCls).transit({ opacity: 1});

                        setTimeout(function () {
                            $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).css({transition: 'initial'});
                        }, 350);
                    }
                },

                handleCurrentScrollPosition: () => {

                    const systemCurrentScroll = $(document).scrollTop();

                    let currentMenu = null;


                    const windowWidth = $(window).width();

                    let modifierDefault = 300;

                    if(windowWidth > 1024) {
                        modifierDefault = 300;
                    } else if(windowWidth <= 1024 && windowWidth > 850) {
                        modifierDefault = 200;
                    } else if(windowWidth <= 850 && windowWidth > 767) {
                        modifierDefault = 150;
                    } else if(windowWidth <= 767 && windowWidth > 600) {
                        modifierDefault = 100;
                    } else {
                        modifierDefault = 50;
                    }

                    let modifier = [0];

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    const submenuHeight = $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).outerHeight()

                    for (let key of view.privateVars.itemsKeys) {

                        const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                        let elemHeight = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).outerHeight();

                        modifier.push(((elemHeight > modifierDefault) ? modifierDefault : elemHeight / 2));

                        view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);

                        let nextModifier = modifier.shift();
                        //console.log(key, targetPos.top, systemCurrentScroll, nextModifier);

                        if ((targetPos.top - nextModifier - headerHeight - submenuHeight) < systemCurrentScroll) {
                            currentMenu = key;
                        }
                    }

                    $(view.publicVars.cssId.submenu.headerSeriesSubmenuContentItemCls)
                        .removeClass(view.publicVars.cssId.submenu.isActiveCls.substr(1));

                    $('#' + view.publicVars.cssId.submenu.headerSeriesSubmenuContentItemCls.substr(1) + '-' + currentMenu)
                        .addClass(view.publicVars.cssId.submenu.isActiveCls.substr(1));

                    if (view.privateVars.submenu.current !== currentMenu) {
                        view.privateVars.submenu.current = currentMenu;
                    }
                },

                handleModuleInit: (currentScroll, key, targetPos) => {

                    if (view.privateVars.items.has(key) && view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                        const rect = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key)[0].getBoundingClientRect();
                        const scrollPlusWindowHeight = $(window).height() + currentScroll;

                        if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height))) {

                            view.methods.fireModuleStart(key);

                        }
                    }

                },

                performNavigate: (target, options) => {

                    view.privateVars.submenu.target = target;

                    view.methods.fireModuleStart(target);

                    $('html, body').finish();

                    let easing = (options && options.easing) || 'easeInOutExpo';

                    const masterSpeed = (options && options.speed !== undefined && options.speed >= 0) ? options.speed : '';

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    const submenuHeight = $(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).outerHeight();

                    // const modifier = - (headerHeight + submenuHeight) + 2;
                    let modifier = - (headerHeight) - parseInt($(view.publicVars.cssId.submenu.headerSeriesSubmenuCls).css('margin-bottom'));

                    if(target === 'featured') {
                        modifier = modifier - 1;
                    }

                    var speed = 0;

                    let shouldFireAnim = (options && options.fireAnim) || 0;

                    view.privateVars.canNavigateAction = 1;

                    const systemCurrentScroll = $(document).scrollTop();
                    const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + target).offset();

                    var diff = Math.abs(systemCurrentScroll - targetPos.top);

                    if (diff > 1000) {
                        speed = 800 + (diff / 3);

                    } else {
                        speed = 1000;
                    }

                    container.msg('system - diff for navigation ' + diff);

                    if (masterSpeed !== '') {
                        speed = masterSpeed;
                    }

                    container.msg('system - navigation anim speed ' + speed);

                    if (target == view.privateVars.submenu.current) {
                        shouldFireAnim = 0;
                    } else {
                        $(view.publicVars.cssId.submenu.headerSeriesSubmenuContentItemCls).removeClass(view.publicVars.cssId.submenu.isActiveCls.substr(1));
                    }

                    jump.jumpTo(view.publicVars.cssId.layout.navigateTargetId + '-' + target, {
                        modifier: modifier,
                        easing: easing,
                        speed: speed
                    }, function () {
                        $('#' + view.publicVars.cssId.submenu.headerSeriesSubmenuContentItemCls.substr(1) + '-' + target)
                            .addClass(view.publicVars.cssId.submenu.isActiveCls.substr(1));

                        view.privateVars.canNavigateAction = 0;
                        view.privateVars.submenu.target = null;

                        if (view.privateVars.submenu.current !== target) {
                            view.privateVars.submenu.current = target;

                        }
                    });
                },

                fireModuleStart: (key) => {
                    if (
                        view.privateVars.items.has(key) &&
                        view.privateVars.items.get(key).module &&
                        view.privateVars.items.get(key).init === false) {
                        view.privateVars.items.get(key).init = true;
                        view.privateVars.items.get(key).module.init(
                            view.privateVars.items.get(key).config,
                            view.privateVars.items.get(key).callbacks
                        );
                    }
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
